import { cn } from "@qw/ui";
import type { ComponentProps, FC, KeyboardEvent } from "react";

export interface ConversationLinkButtonProps extends ComponentProps<"div"> {
  isCurrent?: boolean;
  isPending?: boolean;
  isUnread?: boolean;
}

export const ConversationLinkButton: FC<ConversationLinkButtonProps> = ({
  isCurrent,
  isUnread,
  className,
  onClick,
  ...props
}) => {
  const handleKeyUp = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.code === "Enter" || event.code === "Space") {
      event.preventDefault();
      event.currentTarget.click();
    }
  };

  return (
    // IMPORTANT: We use a div here instead of a button, because the Checkbox component uses a button internally.
    // If we use a button, we will get an error in the console.
    <div
      {...props}
      role="button"
      tabIndex={0}
      onKeyUp={handleKeyUp}
      onClick={onClick}
      className={cn(
        "group/conversation-link gap-x-2 @3xl:gap-x-4 grid grid-cols-[3rem_minmax(0,1fr)_3rem] @3xl:grid-cols-[3.75rem_minmax(0,1fr)_5rem] w-full py-3 pr-3 pl-0 relative select-none transition-colors text-start cursor-pointer hover:bg-foreground/5 overflow-hidden",
        "ring-offset-background focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        !isCurrent && isUnread && "bg-card",
        isUnread ? "text-foreground" : "text-foreground/80",
        isCurrent && "bg-primary! text-primary-foreground!",
        className
      )}
    >
      {props.children}
    </div>
  );
};
